

export default {
  async showModal({ commit }, message) {
    commit('SHOW_MODAL', message)
  },
  async hideModal({ commit }) {
    commit('HIDE_MODAL')
  }
}